<nz-layout>
  <nz-header>
    <span class="section-header">{{ "Tracheostomy" | translate }}</span>
  </nz-header>
  <nz-content>
    <nz-tabset nzType="card">
      @for (tab of submenu; track tab; let i = $index) {
        @if (isInpatientView() && tab.path == "assessment") {
          <nz-tab [nzTitle]="titleTemplate1">
            <ng-template #titleTemplate1>
              <i nz-icon nzType="icons:assessment"></i
              >{{ "Assessment" | translate }}
            </ng-template>
            <app-assessment-section [submenu]="tab" />
          </nz-tab>
        }
        @if (isInpatientView() && tab.path == "patientCharacteristics") {
          <nz-tab [nzTitle]="titleTemplate">
            <ng-template #titleTemplate>
              <i nz-icon nzType="icons:patientCharacteristics"></i
              >{{ "Patient Characteristics" | translate }}
            </ng-template>
            @for (tabcont of tab?.childModules; track tabcont; let j = $index) {
              @if (tabcont.path == componentPaths.socialHistory) {
                <app-social-history />
              }
              @if (tabcont.path == componentPaths.comorbidity) {
                <app-comorbidity />
              }
            }
          </nz-tab>
        }
        @if (isInpatientView() && tab.path == "etiology") {
          <nz-tab [nzTitle]="titleTemplate2">
            <ng-template #titleTemplate2>
              <i nz-icon nzType="icons:etiology"></i
              >{{ "Etiology" | translate }}
            </ng-template>
            <app-etiology />
          </nz-tab>
        }
        @if (isInpatientView() && tab.path == "laboratory") {
          <nz-tab [nzTitle]="titleTemplate3">
            <ng-template #titleTemplate3>
              <i nz-icon nzType="icons:laboratory"></i>
              {{ "Laboratory" | translate }}
            </ng-template>
            @for (tabcont of tab?.childModules; track tabcont; let j = $index) {
              @if (tabcont.path == componentPaths.laboratoryFiles) {
                <app-laboratory-file />
              }
              @if (tabcont.path == componentPaths.laboratoryResults) {
                <app-laboratory-result-section />
              }
            }
          </nz-tab>
        }
        @if (isInpatientView() && tab.path == "imaging") {
          <nz-tab [nzTitle]="titleTemplate6">
            <ng-template #titleTemplate6>
              <i nz-icon nzType="icons:mri"></i>{{ "Imaging" | translate }}
            </ng-template>
            @for (tabcont of tab?.childModules; track tabcont; let j = $index) {
              @if (tabcont.path == componentPaths.imagingFiles) {
                <app-imaging-files />
              }
              @if (tabcont.path == componentPaths.ctParameters) {
                <app-ct-parameters />
              }
              @if (
                tabcont.path == componentPaths.multipleSclerosisSegmentation
              ) {
                <app-multiple-sclerosis-segmentation />
              }
              @if (tabcont.path == componentPaths.preciousMedSamSegmentation) {
                <app-precious-med-sam-segmentation />
              }
            }
          </nz-tab>
        }
        @if (isInpatientView() && tab.path == "tubeCharacteristics") {
          <nz-tab [nzTitle]="titleTemplate5">
            <ng-template #titleTemplate5>
              <i nz-icon nzType="icons:tube"></i
              >{{ "Tube Characteristics" | translate }}
            </ng-template>
            <app-tube-characteristics />
          </nz-tab>
        }
      }
    </nz-tabset>
  </nz-content>
</nz-layout>
